import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";
import { push } from "connected-react-router";
import axios from "axios";
import swal from "sweetalert";
import { Button, Col, Form, FormGroup, Input, Label } from "reactstrap";
import Widget from "../../components/Widget/Widget";
import {
  API_TIMEOUT,
  NIRLABA_JENIS,
  NIRLABA_LEMBAGA,
  NIRLABA_PROGRAM,
} from "../../utils/index";
import {
  getMitraLembagaId,
  getStoredUser,
  isAdminMitra,
} from "../../utils/adminMitra";

const currentYear = new Date().getFullYear();
const listTahun = Array.from({ length: currentYear - 2018 + 1 }, (_, i) =>
  String(2018 + i)
).reverse();

const ProgramNirlabaForm = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [lembaga, setLembaga] = useState([]);
  const [jenisAll, setJenisAll] = useState([]);
  const [idLembaga, setIdLembaga] = useState("");
  const [bantuan, setBantuan] = useState("");
  const [tahun, setTahun] = useState(String(currentYear));
  const [totalDana, setTotalDana] = useState("");
  const [jmlPenerima, setJmlPenerima] = useState("");
  const [bentuk, setBentuk] = useState("");
  const [target, setTarget] = useState("");
  const [jenis, setJenis] = useState("");
  const [catatan, setCatatan] = useState("");

  useEffect(() => {
    axios
      .get(NIRLABA_LEMBAGA, { timeout: API_TIMEOUT })
      .then((res) => {
        const user = getStoredUser();
        const lid = getMitraLembagaId(user);
        let data = res.data?.data || [];
        if (isAdminMitra(user) && lid) {
          data = data.filter((x) => Number(x.id) === lid);
          setIdLembaga(String(lid));
        }
        setLembaga(data);
      })
      .catch((err) => alert(err));
    axios
      .get(NIRLABA_JENIS, { timeout: API_TIMEOUT })
      .then((res) => {
        const user = getStoredUser();
        const lid = getMitraLembagaId(user);
        let data = res.data?.data || [];
        if (isAdminMitra(user) && lid) {
          data = data.filter((x) => Number(x.id_lembaga) === lid);
        }
        setJenisAll(data);
      })
      .catch((err) => alert(err));
  }, []);

  useEffect(() => {
    if (!id) return;
    axios
      .get(NIRLABA_PROGRAM + "/" + id, { timeout: API_TIMEOUT })
      .then((res) => {
        const row = res.data?.data?.[0];
        if (!row) return;
        setIdLembaga(String(row.id_lembaga || ""));
        setBantuan(row.bantuan || "");
        setTahun(String(row.tahun || currentYear));
        setTotalDana(row.total_dana || "");
        setJmlPenerima(row.jml_penerima || "");
        setBentuk(row.bentuk || "");
        setTarget(row.target || "");
        setJenis(row.jenis || "");
        setCatatan(row.catatan || "");
      })
      .catch((err) => alert(err));
  }, [id]);

  const programLembaga = jenisAll.filter(
    (item) => String(item.id_lembaga) === String(idLembaga)
  );

  const pilihProgram = (nama) => {
    setBantuan(nama);
    const found = programLembaga.find((item) => item.bantuan === nama);
    if (found) {
      setBentuk(found.bentuk || "");
      setTarget(found.target || "");
      setJenis(found.jenis || "");
    }
  };

  const simpan = async (e) => {
    e.preventDefault();
    if (!id) {
      const cek = await axios.post(
        NIRLABA_PROGRAM + "/check",
        { id_lembaga: idLembaga, bantuan, tahun },
        { timeout: API_TIMEOUT }
      );
      if ((cek.data?.data || []).length) {
        swal("Tidak bisa", "Program tahun ini sudah diinput untuk lembaga tersebut", "warning");
        return;
      }
    }
    const payload = {
      id_lembaga: idLembaga,
      bantuan,
      tahun,
      total_dana: totalDana,
      jml_penerima: jmlPenerima,
      bentuk,
      target,
      jenis,
      catatan,
    };
    const req = id
      ? axios.patch(NIRLABA_PROGRAM + "/" + id, payload, { timeout: API_TIMEOUT })
      : axios.post(NIRLABA_PROGRAM, payload, { timeout: API_TIMEOUT });
    req
      .then((res) => {
        if (res.data?.success === 1) {
          swal("Sukses", "Program tahun tersimpan", "success");
          dispatch(push("/admin/nirlaba/program"));
        } else {
          swal("Gagal", res.data?.message || "Gagal simpan", "error");
        }
      })
      .catch((err) => swal("Gagal", err.message, "error"));
  };

  return (
    <div>
      <div className="page-top-line">
        <h2 className="page-title">
          {id ? "Edit program tahun" : "Input program tahun mitra"}
        </h2>
      </div>
      <Widget>
        <Form onSubmit={simpan}>
          <FormGroup row>
            <Label md={3} className="text-md-right">
              Tahun
            </Label>
            <Col md={8}>
              <Input type="select" value={tahun} onChange={(e) => setTahun(e.target.value)}>
                {listTahun.map((t) => (
                  <option key={t} value={t}>
                    {t}
                  </option>
                ))}
              </Input>
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label md={3} className="text-md-right">
              Lembaga
            </Label>
            <Col md={8}>
              <Input
                type="select"
                value={idLembaga}
                onChange={(e) => {
                  setIdLembaga(e.target.value);
                  setBantuan("");
                }}
                required
                disabled={isAdminMitra(getStoredUser())}
              >
                <option value="">Pilih lembaga</option>
                {lembaga.map((item) => (
                  <option key={item.id} value={item.id}>
                    {item.nama_lembaga}
                  </option>
                ))}
              </Input>
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label md={3} className="text-md-right">
              Program
            </Label>
            <Col md={8}>
              <Input
                type="select"
                value={bantuan}
                onChange={(e) => pilihProgram(e.target.value)}
                required
              >
                <option value="">Pilih program</option>
                {programLembaga.map((item) => (
                  <option key={item.id} value={item.bantuan}>
                    {item.bantuan}
                  </option>
                ))}
              </Input>
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label md={3} className="text-md-right">
              Total dana
            </Label>
            <Col md={8}>
              <Input
                type="number"
                value={totalDana}
                onChange={(e) => setTotalDana(e.target.value)}
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label md={3} className="text-md-right">
              Jumlah penerima (kuota)
            </Label>
            <Col md={8}>
              <Input
                type="number"
                value={jmlPenerima}
                onChange={(e) => setJmlPenerima(e.target.value)}
              />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label md={3} className="text-md-right">
              Catatan
            </Label>
            <Col md={8}>
              <Input type="textarea" value={catatan} onChange={(e) => setCatatan(e.target.value)} />
            </Col>
          </FormGroup>
          <FormGroup row>
            <Label md={3} />
            <Col md={8}>
              <Button color="primary" type="submit" className="mr-2">
                Simpan
              </Button>
              <Button
                color="secondary"
                type="button"
                onClick={() => dispatch(push("/admin/nirlaba/program"))}
              >
                Batal
              </Button>
            </Col>
          </FormGroup>
        </Form>
      </Widget>
    </div>
  );
};

export default ProgramNirlabaForm;
